import React, { useRef } from 'react'

import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Tooltip as ReactTooltip } from 'react-tooltip'

import generateID from '@/utils/helpers/generateID'
import { isString } from '@/utils/helpers/typeChecking'

import Span from '@/ui/Span'
import Text from '@/ui/Text'

import 'react-tooltip/dist/react-tooltip.css'

const Tooltip = ({
  children,
  message,
  messageId,
  direction = 'top',
  hasBorder = true,
  properties = {},
  ...props
}) => {
  const id = useRef(generateID())
  const { formatMessage } = useIntl()

  if (!message && !messageId) {
    return children
  }

  message = message ?? formatMessage({ id: messageId })

  return (
    <>
      <Span
        data-tooltip-id={id.current}
        data-tooltip-wrapper='span'
        display='inline-flex'
        onClick={(e) => e.stopPropagation()}
        {...props}
      >
        {children}
      </Span>
      {message && (
        <ReactTooltip
          id={id.current}
          place={direction}
          clickable
          border={`1px solid ${hasBorder ? '#6284C6' : 'transparent'}`}
          opacity={1}
          positionStrategy='fixed'
          {...properties}
          style={{
            background: '#fff',
            borderRadius: '9px',
            padding: '0.6875rem 1rem',
            cursor: 'default',
            width: 'fit-content',
          }}
        >
          {isString(message) ? (
            <Text as='span' variant='body12n'>
              {message}
            </Text>
          ) : (
            message
          )}
        </ReactTooltip>
      )}
    </>
  )
}

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  direction: PropTypes.oneOf([
    'top',
    'top-start',
    'top-end',
    'right',
    'right-start',
    'right-end',
    'bottom',
    'bottom-start',
    'bottom-end',
    'left',
    'left-start',
    'left-end',
  ]),
  hasBorder: PropTypes.bool,
  messageId: PropTypes.string,
  properties: PropTypes.object,
}

export default Tooltip
